<footer class="site-footer">
  <div class="layout-fluid-constrained layout-align-center wrap">
    <div class="footer-logo">
      <span class="logo-mark" aria-hidden="true">
        <svg width="28" height="28" viewBox="0 0 30 30" fill="none"><path d="M3 18c6-2 10-1 14 1 4-8 8-11 10-12-6 0-16 2-24 11z" fill="#8fc043"></path><path d="M3 18c8-5 17-7 24-11-8 8-16 12-24 11z" fill="#e6ecef"></path></svg>
      </span>
      Мини Заем
    </div>
    <address>
      София 1408, ул. "Балша" № 17, офис 1<br>
      Финансова институция съгласно<br>
      Удостоверение № BGR000211<br>
      Издадено от БНБ на 19.10.2010 г.
    </address>
  </div>
</footer>
